export const CUSTOMER_PASSWORD_MIN_LENGTH = 6;
export const STAFF_PASSWORD_MIN_LENGTH = 12;

/** Grants come from server authorization; any non-customer grant keeps the staff minimum. */
export function passwordMinimumLength(permissions: Iterable<string>): number {
  const grants = [...permissions];
  return grants.length === 1 && grants[0] === "customer-portal:read"
    ? CUSTOMER_PASSWORD_MIN_LENGTH
    : STAFF_PASSWORD_MIN_LENGTH;
}
